import React, { useCallback, useEffect, useState } from "react";
// import XGridDemo from "components/UI/Grid/XGrid";
import { document as titles } from "consts/titulos-de-tablas";
import tableStyles from "styles/pages/Tables.module.scss";
import { Buttons, TransitionModal, HeaderButton } from "components";
import { ACTIONS } from "consts/Actions";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import Delete from "@mui/icons-material/Delete";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Filters from "components/Filters";
import { useFormik } from "formik";
import { Box } from "@mui/material";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { modalData, routeInfo, rowSelected, userCredentials } from "recoilState/GlobalState";
import { DeleteModal, InsertModal, UpdateModal, UploadModal } from "./Actions";
import Participants from "./Actions/Participants";
import { RequestServiceGet } from "services/services-mia/RequestServiceGet";
import { Routes } from "consts/Routes-App";
import PreviewIcon from '@mui/icons-material/Preview';
import ViewDoc from "./Actions/ViewDoc/ViewDoc";
import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import XGridServer from "components/UI/Grid/XGridServer";
import { SBMDocumentoGet, SBMTipoDeDocumentoGet } from "services/services-mia";
import { PublishRounded } from "@mui/icons-material";
import PublicModal from "./Actions/Public";
import { useNavigate } from "react-router-dom";
import { useMIAService } from "hooks/useMIAService";

export default function Documents() {
    //Local States 
    const [documentType, setDocuemntType] = useState([]);
    const [documentStatus, setDocumentStatus] = useState([]);
    const [, setLoadingRow] = useState(false);
    const setRoute = useSetRecoilState(routeInfo);
    //Global States
    const { action } = useRecoilValue(modalData);
    const credentials = useRecoilValue(userCredentials);
    const xgridRowSelected = useRecoilValue(rowSelected);
    const setRowSelected = useSetRecoilState(rowSelected);
    const [forceUpload, setForceUpload] = useState(false);
    const navigate = useNavigate();
    const getSBMTipoDeDocumento = useMIAService(SBMTipoDeDocumentoGet, false);

    const updateList = useCallback(() => { setForceUpload((value) => !value); }, [])
    // Hooks 
    const formik = useFormik({
        initialValues: {
            tipo: "X",
            estado: "X",
            referencia: null,
            documento: null,
            idExterna: null,
            desde: null,
            hasta: null,
            nombreDocumento: null
        },
        onSubmit: () => {
            updateList()
        },
    });

    const resetFilters = () => {
        formik.setFieldValue("tipo", "X")
        formik.setFieldValue("estado", "X")
        formik.setFieldValue("referencia", "")
        formik.setFieldValue("documento", "")
        formik.setFieldValue("idExterna", "")
        formik.setFieldValue("desde", "")
        formik.setFieldValue("hasta", "")
        formik.setFieldValue("nombreDocumento", "")
        return updateList();
    }

    useEffect(() => {
        setRowSelected({ status: false, row: {} });
        Promise.all([getDocuments(), getDocumentTypes(), getDocumentStatus()]);
        setRoute(Routes.documentTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDocuments = async (page, pageSize) => {
        setLoadingRow(true)
        const { result, total } = await SBMDocumentoGet({
            sbmTipoDocumentoId: formik.values.tipo === "X" ? null : formik.values.tipo,
            sbmEstadoId: formik.values.estado === "X" ? null : formik.values.estado,
            sbmDocumentoReferencia: formik.values.referencia,
            usuarioNroDeDocumentoX: formik.values.documento,
            fechaDesde: formik.values.desde,
            fechaHasta: formik.values.hasta,
            sbmDocumentoNombre: formik.values.nombreDocumento,
            sbmDocumentoIdExterna: formik.values.idExterna,
            page: page + 1,
            pageSize,
        }, credentials);
        const newRows = await result?.map((document) => {
            return {
                id: document.sbmDocumentoId,
                nombre: document.sbmDocumentoNombre,
                tipoDocumentoId: document.sbmTipoDeDocumentoId,
                version: document.sbmDocumentoVersion,
                firmantesInternosDefinidos: document.sbmDocumentoFirmantesInternosDefinidos,
                firmantesExternosDefinidos: document.sbmDocumentoFirmantesExternosDefinidos,
                requiereFirma: document.sbmDocumentoRequiereFirma,
                descripcion: document.sbmDocumentoDescripcion,
                firmantesInternos: document.sbmDocumentoFirmantesInternos,
                firmantesExternos: document.sbmDocumentoFirmantesExternos,
                firmantesInternosRealizados: document.sbmDocumentoFirmantesInternosRealizados,
                firmantesExternosRealizados: document.sbmDocumentoFirmantesExternosRealizados,
                fechaDocumento: document.sbmDocumentoFecha,
                documentoEstado: document.sbmEstadoCod,
                sbmTipoDeDocumentoPHTickets: document.sbmTipoDeDocumentoPHTickets,
                sbmDocumentoTipoFirma: document.sbmDocumentoTipoFirma,
                sbmDocumentoTicketsTag: document.sbmDocumentoTicketsTag,
                [titles[0]]: document.sbmDocumentoNombre,
                [titles[1]]: document.sbmTipoDeDocumentoNombre,
                [titles[2]]: document.sbmDocumentoFecha,
                [titles[3]]: document.sbmDocumentoIDExterna,
                [titles[4]]: document.sbmDocumentoDescripcion,
                [titles[5]]: document.sbmDocumentoTipoFirma,
                [titles[6]]: `${document.sbmDocumentoFirmantesInternosRealizados} de ${document.sbmDocumentoFirmantesInternos}`,
                [titles[7]]: `${document.sbmDocumentoFirmantesExternosRealizados} de ${document.sbmDocumentoFirmantesExternos}`,
                [titles[8]]: document.sbmDocumentoFechaEstado,
                [titles[9]]: document.sbmEstadoNombre,
                [titles[10]]: document.sbmDocumentoGrupo,
                [titles[11]]: document.sbmDocumentoReferencia,
            };
        });
        return {
            rows: newRows,
            rowCount: total,
        };
    };

    const getDocumentTypes = async () => {
        try {
            const response = await getSBMTipoDeDocumento();
            const responseToDocumentType = response.result.map((document) => {
                const { sbmTipoDeDocumentoId, sbmTipoDeDocumentoNombre } = document;
                return {
                    tipoCod: sbmTipoDeDocumentoId,
                    tipoNombre: sbmTipoDeDocumentoNombre,
                }
            })
            setDocuemntType(responseToDocumentType);
        } catch (e) {
            //Manejar error; 
            console.error("Error fetching document types:", e);
        }
    }
    const getDocumentStatus = async () => {
        try {
            const body = {
                service: "SBMEstadoGet",
                params: {}
            }
            const response = await RequestServiceGet(body, credentials);
            const responseToDocumentStatus = response.map((document) => {
                const { SBMEstadoId, SBMEstadoCod, SBMEstadoNombre } = document;
                return {
                    estadoId: SBMEstadoId,
                    estadoCod: SBMEstadoCod,
                    estadoNombre: SBMEstadoNombre,
                }
            })
            setDocumentStatus(responseToDocumentStatus);
        } catch (e) {
            //Manejar error; 
        }
    }

    const hasAllInternosDefined = (xgridRowSelected.row.firmantesInternosDefinidos ?? 0) === (xgridRowSelected.row.firmantesInternos ?? 0);
    const hasAllExternosDefined = (xgridRowSelected.row.firmantesExternosDefinidos ?? 0) === (xgridRowSelected.row.firmantesExternos ?? 0);
    const canPublish =
        xgridRowSelected.row.documentoEstado === "S" &&
        hasAllInternosDefined &&
        hasAllExternosDefined;

    const handleMainModalClose = () => {
        if (action === "participants") {
            updateList();
            setRowSelected({ status: false, row: {} });
        }
    };

    return (
        <section className={tableStyles.section}>

            <Box display={"flex"} justifyContent="space-between" alignItems={"center"} flexWrap={"wrap-reverse"} >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Filters
                        formik={formik}
                        inputsRender={[
                            { type: "text", name: "nombreDocumento", label: "Nombre de documento", disabled: false },
                            { type: "text", name: "documento", label: "Nro.Doc del firmante", disabled: false },
                            { type: "text", name: "idExterna", label: "Identificación externa", disabled: false },
                            { type: "select", name: "tipo", label: "Tipo documento", disabled: false, options: [{ tipoCod: "todos", tipoNombre: "Todos" }, ...documentType], firstOptionKey: "tipoCod", firstOptionName: "tipoNombre", firstOptionValue: "tipoCod" },
                            { type: "select", name: "estado", label: "Estado", disabled: false, options: [{ estadoId: "X", estadoNombre: "Todos" }, ...documentStatus], firstOptionKey: "estadoId", firstOptionName: "estadoNombre", firstOptionValue: "estadoId" },
                            { type: "date", name: "desde", label: "Desde", disabled: false },
                            { type: "date", name: "hasta", label: "Hasta", disabled: false },
                            { type: "text", name: "referencia", label: "Referencia", disabled: false },
                        ]}
                    />
                    <HeaderButton text={"Limpiar filtros"} onClick={() => resetFilters()}>
                        <FilterAltOffRoundedIcon />
                    </HeaderButton>
                </div>
                <Buttons filtersApplied={true}>
                    <HeaderButton
                        text={"Actualizar"}
                        handleClick={updateList}
                        action="noOpen"
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        disabled={xgridRowSelected.status === true}
                        text={"Crear"}
                        data={{
                            action: ACTIONS.INSERT,
                            title: "Nuevo Documento",
                            button: "Registrar",
                        }}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        disabled={xgridRowSelected.status === false || !['R', 'S'].includes(xgridRowSelected.row.documentoEstado)}
                        text={"Subir documento"}
                        data={{
                            action: "uploadfile",
                            title: "Subir Documento",
                            button: "Subir documento",
                        }}
                    >
                        <CloudUploadIcon />
                    </HeaderButton>
                    <HeaderButton
                        disabled={xgridRowSelected.status === false || !['S', 'P', 'F'].includes(xgridRowSelected.row.documentoEstado)}
                        text={"Participantes"}
                        data={{
                            action: "participants",
                            title: "Participantes",
                            button: "Participantes",
                        }}
                    >
                        <AccountCircleIcon />
                    </HeaderButton>
                    <HeaderButton
                        disabled={!canPublish}
                        text={"Publicar"}
                        onClick={() => {
                            if (!xgridRowSelected.status) return;
                            navigate(`${Routes.pdfAnnotationPublisher.route}?documentId=${xgridRowSelected.row.id}`);
                        }}
                    >
                        <PublishRounded />
                    </HeaderButton>
                    <HeaderButton
                        disabled={xgridRowSelected.status === false || !['S', 'P', 'F'].includes(xgridRowSelected.row.documentoEstado)}
                        text={"Ver documento"}
                        data={{
                            action: ACTIONS.VIEW,
                            title: "Ver Documento",
                            button: "Ver Documento",
                        }}
                    >
                        <PreviewIcon />
                    </HeaderButton>
                    <HeaderButton
                        disabled={xgridRowSelected.status === false || !['R', 'S'].includes(xgridRowSelected.row.documentoEstado)}
                        text={"Editar"}
                        data={{
                            action: ACTIONS.UPDATE,
                            title: "Editar",
                            button: "Editar",
                        }}>
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        disabled={xgridRowSelected.status === false || !['R', 'S'].includes(xgridRowSelected.row.documentoEstado)}
                        text={"Eliminar"}
                        data={{
                            action: ACTIONS.DELETE,
                            title: "Eliminar",
                            button: "Eliminar",
                        }}>
                        <Delete />
                    </HeaderButton>
                </Buttons>
            </Box>

            <TransitionModal
                confirmationModal={
                    (action === ACTIONS.INSERT || action === ACTIONS.UPDATE) ??
                    true
                }
                customOnClose={handleMainModalClose}
            >
                {
                    action === ACTIONS.INSERT && (
                        <InsertModal updateList={updateList} />
                    )
                }
                {
                    action === ACTIONS.VIEW && (
                        <ViewDoc updateList={updateList} />
                    )
                }
                {
                    action === ACTIONS.UPDATE && (
                        <UpdateModal updateList={updateList} />
                    )
                }
                {
                    action === ACTIONS.DELETE && (
                        <DeleteModal updateList={updateList} />
                    )
                }
                {
                    action === "participants" && (
                        <Participants rows={xgridRowSelected.row} />
                    )
                }
                {
                    action === "uploadfile" && (
                        <UploadModal updateList={updateList} />
                    )
                }
                {
                    action === "public" && (
                        <PublicModal updateList={updateList} />
                    )
                }

            </TransitionModal>
            {/* <XGridDemo
                titles={titles}
                rows={rows}
                loading={loadingRow}
            /> */}
            <XGridServer
                titles={titles}
                updateList={getDocuments}
                forceUpload={forceUpload}
            // secondarySelected={rowSelected}
            // setSecondarySelected={setRowSelected}
            />
        </section>
    );
}